import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { apiClient } from "@/lib/api";
import { CreditCard } from "lucide-react";

export default function BillingHistory() {
  const handleManageBilling = async () => {
    try {
      const { url } = await apiClient.createBillingPortalSession();
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error creating billing portal session:", error);
    }
  };
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Billing Management</CardTitle>
          <Button variant="outline" onClick={handleManageBilling}>
            <CreditCard className="w-4 h-4 mr-2" />
            Manage Billing
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600">
          Access your billing portal to update payment methods, download
          invoices, and manage your subscription.
        </p>
      </CardContent>
    </Card>
  );
}
